<template>
  <div id="lista-formularios">
    <div class="lista-formulario-header">
      <div class="lista-formulario-header-titulo">
        {{ titulo }}
      </div>
      <el-link
        v-if="!aberto"
        :underline="false"
        class="lista-formulario-header-botao"
        @click="expandirTodos"
        style="color: #006FB9 !important;"
      >
        Expandir Todos
      </el-link>
    </div>

    <div
      class="lista-formulario-conteiner"
    >
      <ListaFormularioCard
        v-for="(idData, index) of formulario.idDatas"
        :key="index"
        :ref="`ListaFormularioCard_${idData}`"
        :aberto="aberto"
        :client-key="clientKey"
        :entrada-id="index+1"
        :id-data="idData"
        :id-form="formulario.idForm"
      />
    </div>
  </div>
</template>
<script>
import ListaFormularioCard from '@/components/TemplateSolicitacao/componentes/ListaFormularioCard'
import { mapGetters } from 'vuex'

export default {
  name: 'ListaFormalarioSolicitacao',
  components: { ListaFormularioCard },
  props: {
    solicitacao: {
      type: Object
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['aplicacao']),
    clientKey () {
      return this.aplicacao.clientKey
    },
    titulo () {
      return this.solicitacao.agrupador_label
    },
    formulario () {
      if (Array.isArray(this.solicitacao.formularios) && this.solicitacao.formularios[0]) {
        return this.solicitacao.formularios[0]
      }
      return { idDatas: [] }
    },
    aberto () {
      return this.formulario.idDatas.length <= 1
    }
  },
  methods: {
    expandirTodos () {
      this.formulario.idDatas.forEach((idData) => {
        const ref = this.$refs[`ListaFormularioCard_${idData}`]
        if (ref) {
          ref[0].expandir(true)
        }
      })
    }
  }
}
</script>
